'use client';

import { Layout } from 'src/layout';
import { MARK_EVENT_ADDITIONAL_EVENT_MATERIALS } from 'src/markevents';
import { EventOrWebinarType } from 'src/types/backendContent';
import { Form, FormForEnum } from 'src/uikit/Form';

import { useIntersectionObserveForms } from '../../../hooks/useIntersectionObserverForms';
import { HeroEvent } from '../../../snack/components/HeroEvent';
import s from './Event.module.scss';
import {
  EventContent,
  FormBlock,
  RegistryFormBlock,
  WebinarContent,
} from './helperComponents';

export function EventPage({ event }: { event: EventOrWebinarType }) {
  const { pageType } = event;

  const { formRef, setAnchorId } = useIntersectionObserveForms({
    formName: 'webinar-materials',
  });

  const { formRef: formRefRegistry, setAnchorId: setAnchorIdFormRegistry } =
    useIntersectionObserveForms({
      formName: pageType === 'event' ? 'lead-events' : 'webinar-registration',
    });

  const handleClickButtonHero = () => {
    setAnchorId('form');
    setAnchorIdFormRegistry('form');
  };

  return (
    <Layout>
      <div className={s.root}>
        <HeroEvent event={event} onClickButton={handleClickButtonHero} />
        {pageType === 'event' && <EventContent {...event} />}
        {pageType === 'webinar' && <WebinarContent {...event} />}

        {Boolean(event.form) ? (
          <RegistryFormBlock
            ref={formRefRegistry}
            form={event.form}
            eventSessionID={event.eventSessionID}
            eventTitle={event.title}
            markID={event.markID}
            pageType={event.pageType}
            status={event.status}
            isRegistrationClose={event.content?.ctaButton?.isRegistrationClose}
          />
        ) : (
          <FormBlock ref={formRefRegistry} {...event} />
        )}

        {/* Форма получения полезных материлов */}
        {event.status === 'STOP' && event.content?.form?.isShowMaterials && (
          <Form
            ref={formRef}
            id="form-materials"
            analyticsFieldFill={{ formType: 'body' }}
            formVariant="inner"
            agreementName="site_services_consent"
            withLoader
            allFormsSentFormType="subscription"
            additionalFields={{ leadSource: 'webinar', subsegment: '-' }}
            inputPath="v1/webinar_materials"
            title="Получить материалы вебинара"
            subtitle="Укажите актуальный email, чтобы получить ссылку для скачивания материалов"
            successNotice={{
              title:
                'Спасибо! Мы пришлем ссылку для скачивания материалов на указанный email.',
            }}
            buttonTitle="Получить материал"
            fieldsNames={{
              checkboxSubscribe: `Я даю <a target="_blank" href="https://cdn.cloud.ru/backend/docs/security/consent_advertising.pdf">согласие</a> на обработку моих персональных данных и получение рекламных и информационных сообщений в соответствии с условиями <a target="_blank" href="https://cdn.cloud.ru/backend/docs/security/politic.pdf">политики конфиденциальности</a>`,
            }}
            marketingEventIDs={MARK_EVENT_ADDITIONAL_EVENT_MATERIALS}
            isSubscribeForMailingRequired={true}
            formFor={FormForEnum.AdditionalMaterials}
            successfulSubmissonFormAnalytics={{
              formname: 'webinar-materials',
            }}
          />
        )}
      </div>
    </Layout>
  );
}
